export default __webpack_public_path__ + "7d124bb4513da4b01645250224c8a579.svg";